export const parsedHttp = url => {
  let subdomain;
  subdomain = url.includes('http') ? url.split('//').pop() : url;
  return subdomain.includes('.evidence.com')
    ? `https://${subdomain}`
    : `https://${subdomain}.evidence.com`;
};
const getStringBetween = (str, start, end) => {
  const result = str.match(new RegExp(start + '(.*)' + end));
  return result[1];
};

export const filterDomain = url => {
  const scheme = 'https://';
  const tlp = '.evidence.com';
  if (url.includes(scheme) && url.includes(tlp)) {
    const subdomain = getStringBetween(url, scheme, tlp);
    return subdomain;
  }
  return url;
};
